import { useState, useEffect } from 'react';

let isScriptLoaded = false;
let isScriptLoading = false;
const callbacks = [];

export const loadGoogleMapsScript = (callback) => {
  // If the script is already loaded, execute callback immediately
  if (isScriptLoaded && window.google && window.google.maps) {
    callback();
    return;
  }

  // Add callback to queue
  callbacks.push(callback);

  // If script is already in the process of loading, just wait for it
  if (isScriptLoading) {
    return;
  }

  isScriptLoading = true;
  
  const script = document.createElement('script');
  script.type = 'text/javascript';
  // Add region=IN to prefer results from India
  script.src = `https://maps.googleapis.com/maps/api/js?key=AIzaSyAzc8SWiJj2Ycon3eMu49913pe17hVoEUc&libraries=places&region=IN&language=en`;
  
  script.onload = () => {
    isScriptLoaded = true;
    isScriptLoading = false;
    
    // Execute all callbacks
    callbacks.forEach(cb => cb());
    callbacks.length = 0;
  };
  
  document.head.appendChild(script);
  return script;
};

// A custom hook to use the Google Maps script
export const useGoogleMapsScript = () => {
  const [isLoaded, setIsLoaded] = useState(false);
  
  useEffect(() => {
    if (isScriptLoaded && window.google && window.google.maps) {
      setIsLoaded(true);
      return;
    }
    
    loadGoogleMapsScript(() => {
      setIsLoaded(true);
    });
  }, []);
  
  return { isLoaded };
};